import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";

import { Divider, Drawer, Stack, TextField, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import Create from "./create";
import Update from "./update";
import moment from "moment";
import ReceptionistServices from "api/receptionist";
import { useDispatch } from "react-redux";
import { open } from "store/notificationSlice";
import { compareObjects } from "utils/helper";

const Patient = () => {
  const [showDrawerCreate, setShowDrawerCreate] = useState(false);
  const [showDrawerUpdate, setShowDrawerUpdate] = useState(false);
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({
    id: "",
    name: "",
    dob: "",
    sex: "",
    phone: "",
    address: "",
    description: "",
  });
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const [oldData, setOldData] = useState({});

  const columns = [
    {
      field: "id",
      headerName: "#ID",
      width: 30,
      filterable: false,
      renderCell: (params) => {
        return <span>{params.row.id}</span>;
      },
    },
    {
      field: "code",
      headerName: "Mã bệnh nhân",
      width: 160,
    },
    { field: "name", headerName: "Họ và tên", width: 200 },
    {
      field: "phone",
      headerName: "Số điện thoại",
      width: 160,
    },
    {
      field: "sex",
      headerName: "Giới tính",
      width: 110,
      renderCell: (params) => {
        return params.row.sex === "Male" ? <span>Nam</span> : <span>Nữ</span>;
      },
    },
    {
      field: "dob",
      headerName: "Ngày sinh",
      width: 110,
      renderCell: (params) => {
        return <span>{moment(params.row.dob).format("DD-MM-YYYY")}</span>;
      },
    },
    {
      field: "phone",
      headerName: "Điện thoại",
      width: 140,
    },
    {
      field: "address",
      headerName: "Địa chỉ",
      width: 200,
    },

    {
      field: "edit",
      headerName: "Sửa",
      width: 100,
      renderCell: (params) => {
        return (
          <Button onClick={() => handleEdit(params.row)} className="w-full">
            <Edit />
          </Button>
        );
      },
    },
  ];

  const handleShowDrawer = () => {
    setForm({});
    setShowDrawerCreate(!showDrawerCreate);
  };

  const handleEdit = (data) => {
    const Data = {
      ...data,
      password: undefined,
      dob: moment(data?.dob).format("YYYY-MM-DD"),
    };
    setForm(Data);
    setOldData(Data);
    setShowDrawerUpdate(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFormSubmit = async () => {
    try {
      const date = new Date(form?.dob);
      const isoDateString = date.toISOString();
      const payload = {
        ...form,
        dob: isoDateString,
        role: "patient",
      };
      await ReceptionistServices.createUser(payload);
      setShowDrawerCreate(false);
      setForm({});
      fetchPatient();
      dispatch(open({ isNoti: true, message: "Tạo bệnh nhân thành công" }));
    } catch (error) {
      console.log(error);
      dispatch(
        open({
          isNoti: true,
          message: error?.response?.data?.message
            ? error.response.data.message
            : "Yêu cầu nhập đủ các trường",
        })
      );
    }
  };

  const handleFormSubmitUpdate = async () => {
    try {
      const date = new Date(form?.dob);
      const isoDateString = date.toISOString();
      const newData = compareObjects(oldData, form);
      const payload = {
        ...newData,
        password: undefined,
        dob: isoDateString,
      };
      await ReceptionistServices.updateUser(form.id, payload);
      setShowDrawerUpdate(false);
      setForm({});
      fetchPatient();
      dispatch(
        open({ isNoti: true, message: "Cập nhật bệnh nhân thành công" })
      );
    } catch (error) {
      console.log(error);
      dispatch(
        open({
          isNoti: true,
          message: error?.response?.data?.message
            ? error.response.data.message
            : "Yêu cầu nhập đủ các trường",
        })
      );
    }
  };

  const fetchPatient = async () => {
    try {
      const response = await ReceptionistServices.getUser({
        role: "patient",
        perPage: 100,
        search: search ? search : null,
      });
      setRows(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPatient();
  }, [search]);

  return (
    <Box p={3}>
      <Typography variant="h5" my={1} fontWeight="bold">
        Quản lý bệnh nhân
      </Typography>
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
        my={2}
      >
        <Button onClick={handleShowDrawer} variant="contained">
          Thêm bệnh nhân
        </Button>
        <TextField
          name="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          label="Tìm kiếm bệnh nhân"
          placeholder="Tên, số điện thoại, mã bệnh nhân"
          className="w-[300px]"
        />
      </Stack>

      <Drawer
        anchor="right"
        open={showDrawerCreate}
        onClose={handleShowDrawer}
        PaperProps={{
          sx: {
            width: 700,
          },
        }}
      >
        <Typography variant="h5" className="p-3 border border-b">
          Thông tin Bệnh nhân
        </Typography>
        <Create
          form={form}
          handleChangeInput={handleFormChange}
          handleSubmitForm={handleFormSubmit}
        />
      </Drawer>
      <Drawer
        anchor="right"
        open={showDrawerUpdate}
        onClose={() => setShowDrawerUpdate(false)}
        PaperProps={{
          sx: {
            width: 700,
          },
        }}
      >
        <Typography variant="h5" className="p-3 border border-b">
          Chỉnh sửa thông tin Bệnh nhân
        </Typography>
        <Update
          form={form}
          handleChangeInput={handleFormChange}
          handleSubmitFormUpdate={handleFormSubmitUpdate}
        />
      </Drawer>
      <Box style={{ height: "73vh", width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 30, 50, 100]}
          // checkboxSelection
        />
      </Box>
    </Box>
  );
};

export default Patient;
